import { schema } from 'normalizr';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const requestsSchema = new schema.Entity(
  'requests',
  {},
  { idAttribute: 'key' }
);

export const requestsApi = individualKey =>
  apiResourceBuilder({
    name: `cuss/2.0/individuals/${individualKey}/requests`,
    idResolver: ({ key }) => key,
  });

export default individualKey => {
  const api = requestsApi(individualKey);
  return entityActionCreator({ schema: requestsSchema, api });
};



// WEBPACK FOOTER //
// ./src/App/account/actions/customers/requests.js